export function content(state = {}, action) {
  if (action.type === 'EDIT_CONTENT') {
    return { data: action.content };
  }
  return state;
}
